import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, IconAlignmentTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { closeModal, digioCallback, failedVerification, GoToNumber, successVerification } from './actions';
import { ACTION } from './types';
import { api, config } from '../../configs/api';
import { getAppHeader } from '../../configs/config';
import SharedPropsService from '../../SharedPropsService';
import { heightMap } from '../../configs/height';
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = (requestId, tokenId, options, userContextResponse) => ({
    layout: {
        id: ROUTE.DIGIO_DOC_MODAL,
        type: LAYOUTS.MODAL,
        style: {
            height: heightMap[ROUTE.DIGIO_MODAL],
        },
        widgets: [
            {
                id: 'headerStack',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
                padding: {
                    right: 8,
                    top: 8,
                    bottom: 0,
                    left: 0,
                },
            },
            { id: 'digio', type: WIDGET.KYC_DIGIO_MOBILE },
        ],
    },
    datastore: {
        spaceXL: { size: SizeTypeTokens.Size10 },
        headerStack: {
            type: StackType.row,
            alignItems: StackAlignItems.flexEnd,
            justifyContent: StackJustifyContent.flexEnd,
            widgetItems: [{ id: 'leadIcon', type: WIDGET.BUTTON }],
        },
        leadIcon: {
            label: '',
            type: ButtonTypeTokens.SmallGhost,
            width: ButtonWidthTypeToken.CONTENT,
            stack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
            },
            icon: {
                name: IconTokens.Cancel,
                align: IconAlignmentTokens.right,
                size: IconSizeTokens.XXXXL,
            },
            action: {
                type: ACTION.CANCEL_DIGIO,
                payload: {},
                routeId: ROUTE.DIGIO_DOC_MODAL,
            },
        },
        digio: {
            options: options,
            digioDocumentId: requestId,
            identifier: userContextResponse.data.user.phoneNumber,
            action: {
                type: ACTION.DIGIO_ANDROID_CALLBACK,
                routeId: ROUTE.DIGIO_DOC_MODAL,
                payload: {
                    type: null,
                    error: null,
                },
            },
        },
    },
});
export const digioDocsModal = {
    onLoad: async ({ network }) => {
        const user = await SharedPropsService.getUser();
        const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
        const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
        const response = await network.get(`${api.digioDocsInitiateRequest}${applicationId}`, {
            headers: await getAppHeader(),
        });
        const stepperResponse = response.data.stepResponseObject;
        const tokenId = null;
        const options = {
            environment: config.DIGIO_ENVIRONMENT,
            theme: {
                primaryColor: '#234FDA',
                secondaryColor: '#234FDA',
            },
            is_iframe: true,
            logo: 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
            fontFamily: 'Poppins',
            fontUrl: 'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
        };
        return Promise.resolve(template(stepperResponse, tokenId, options, userContextResponse));
    },
    actions: {
        [ACTION.GOTO_PHONE]: GoToNumber,
        [ACTION.DIGIO_ANDROID_CALLBACK]: digioCallback,
        [ACTION.CANCEL_DIGIO]: closeModal,
        [ACTION.SUCCESS_VERIFICATION]: successVerification,
        [ACTION.FAILED_VERIFICATION]: failedVerification
    },
};
